import { get, post, ApiBase } from '@ssr/api/request'
import Cookies from 'js-cookie'

function bankGetList() {
  const userToken = Cookies.get('insta_access_token')
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(
    `${ApiBase.infrPointService}/point/service/questionbank/getListNew`,
    {
      'X-Language': language,
      template: 'activity_answer_questions',
    },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}

function bankCheckAnswer({ questionId, answer, checkIdentifier }) {
  const userToken = Cookies.get('insta_access_token')
  return post(
    `${ApiBase.infrPointService}/point/service/questionbank/checkAnswer`,
    {
      questionId,
      answer,
      checkIdentifier,
    },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function bankSubmit({ submitInfoList, checkIdentifier }) {
  const userToken = Cookies.get('insta_access_token')
  return post(
    `${ApiBase.infrPointService}/point/service/questionbank/submit`,
    {
      template: 'activity_answer_questions',
      submitInfoList,
      checkIdentifier,
    },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function bankCheck() {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/point/question/bank/activity_answer_questions/check`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}

function quizGetList(query) {
  const userToken = Cookies.get('insta_access_token')
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(
    `${ApiBase.infrPointService}/point/question/quiz/getList`,
    { 'X-Language': language, ...query },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function quizGetInfoById(id) {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/point/question/quiz/getInfoById/${id}`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function quizSubmit(data) {
  const userToken = Cookies.get('insta_access_token')
  return post(`${ApiBase.infrPointService}/point/question/quiz/submit`, data, {
    headers: {
      'X-User-Token': userToken,
    },
  })
}
function quizGetMyList() {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/point/question/quiz/getMyList`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}

function lotteryGetCount() {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/credit/lottery/getCount`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryGetAwardsMsg() {
  return get(`${ApiBase.infrPointService}/credit/lottery/getAwardsMsg`)
}
function lotteryStartLotteryDraw() {
  const userToken = Cookies.get('insta_access_token')
  return post(
    `${ApiBase.infrPointService}/credit/lottery/startLotteryDraw`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}

function lotteryDeleteRecord() {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/credit/lottery/deleteRecord`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryCheckIsLotteryDrawPlus() {
  const userToken = Cookies.get('insta_access_token')
  return get(
    `${ApiBase.infrPointService}/credit/lottery/checkIsLotteryDrawPlus`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryStartLotteryDrawPlus() {
  const userToken = Cookies.get('insta_access_token')
  return post(
    `${ApiBase.infrPointService}/credit/lottery/startLotteryDrawPlus`,
    {},
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryPrizeRecordPlus() {
  return get(`${ApiBase.infrPointService}/credit/lottery/prizeRecordPlus`)
}
function lotteryGetPrizeProductList() {
  return get(`${ApiBase.infrPointService}/credit/lottery/getPrizeProductList`)
}
function lotteryGetAwardsPlusMsg() {
  return get(`${ApiBase.infrPointService}/credit/lottery/getAwardsPlusMsg`)
}

function lotteryGetProductList() {
  const userToken = Cookies.get('insta_access_token')
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(
    `${ApiBase.infrPointService}/credit/lottery/getProductList`,
    { 'X-Language': language },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryGetProductListV2(params) {
  const userToken = Cookies.get('insta_access_token')
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(
    `${ApiBase.infrPointService}/point/service/lottery/getProductList`,
    { ...params, 'X-Language': language },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}
function lotteryGetCommonProductList() {
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(`${ApiBase.infrPointService}/credit/lottery/getCommonProductList`, { 'X-Language': language })
}
function lotteryJoin(data) {
  const userToken = Cookies.get('insta_access_token')
  return post(`${ApiBase.infrPointService}/credit/lottery/join`, data, {
    headers: {
      'X-User-Token': userToken,
    },
  })
}
function lotteryGetJoinedProductList() {
  const userToken = Cookies.get('insta_access_token')
  const language = window.isOversea ? 'en-us' : 'zh-cn'
  return get(
    `${ApiBase.infrPointService}/credit/lottery/getJoinedProductList`,
    { 'X-Language': language },
    {
      headers: {
        'X-User-Token': userToken,
      },
    }
  )
}

export default {
  bankGetList,
  bankCheckAnswer,
  bankSubmit,
  bankCheck,

  quizGetList,
  quizGetInfoById,
  quizSubmit,
  quizGetMyList,

  lotteryGetCount,
  lotteryGetAwardsMsg,
  lotteryStartLotteryDraw,
  lotteryDeleteRecord,
  lotteryCheckIsLotteryDrawPlus,
  lotteryStartLotteryDrawPlus,
  lotteryPrizeRecordPlus,
  lotteryGetPrizeProductList,
  lotteryGetAwardsPlusMsg,

  lotteryGetProductList,
  lotteryGetProductListV2,
  lotteryGetCommonProductList,
  lotteryJoin,
  lotteryGetJoinedProductList,
}
